import React, { useEffect, useRef, useState } from 'react'
import { Box, styled } from '@chilipiper/design-system'
import { TextArea, IconButton } from '@chilipiper/design-system/src/new'
import { IconArrowTop } from '@chilipiper/icons/figma-generated/src/icon'

interface Props {
  sendMessage: (text: string) => void
  sendingMessage: boolean
  isDisabled: boolean
}

const StyledForm = styled.form`
  position: relative;
  width: 100%;
`

export const ChatInput = ({ sendMessage, sendingMessage, isDisabled: isDisabledProp }: Props) => {
  const [text, setText] = useState('')
  const ref = useRef<HTMLFormElement>(null)

  const isDisabled = sendingMessage || !text.trim() || isDisabledProp

  const handleSend = () => {
    if (isDisabled) {
      return
    }

    sendMessage(text)
    setText('')
  }

  useEffect(() => {
    if (ref.current) {
      ref.current.querySelector('textarea')?.focus()
    }
  }, [])

  return (
    <StyledForm
      ref={ref}
      onSubmit={e => {
        e.preventDefault()
        handleSend()
      }}
    >
      <TextArea
        label={<TextArea.Label position='hidden'>Chat message</TextArea.Label>}
        value={text}
        placeholder='Enter...'
        onChange={setText}
        minHeight={9}
        maxHeight={15}
        isRequired
        submitOnEnter
      />
      <Box position='absolute' top={2} right={2}>
        <IconButton
          icon={IconArrowTop}
          label='Send Chat message'
          variant='major'
          size={7}
          isDisabled={isDisabled}
          onClick={handleSend}
        />
      </Box>
    </StyledForm>
  )
}
